import { memo } from 'react';
import { Avatar, Box, ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { NotifyIcon } from '../../../Icon';

const useStyles = makeStyles((theme) => ({
  notifyIcon: {
    fontSize: '2rem',
    color: theme.palette.primary.main,
  },
  notifyNum: {
    width: '1.8rem',
    height: '1.8rem',
    backgroundColor: '#ff7270',
    color: theme.palette.font.white,
    fontSize: '0.625rem',
    fontFamily: 'NotoSans-Medium',
    position: 'absolute',
    right: '-0.75rem',
    top: '-0.475rem',
  },
  notifyBox: {
    position: 'relative',
  },
}));

function NotificationTotal({ total, onClick }) {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center" mr="1.875rem" pr="0.75rem">
      <ButtonBase className={classes.notifyBox} onClick={onClick} id="notification-header-total">
        <NotifyIcon className={classes.notifyIcon} />
        {typeof total === 'number' && total > 0 ? (
          <Avatar className={classes.notifyNum}>{total > 99 ? '99+' : total}</Avatar>
        ) : (
          ''
        )}
      </ButtonBase>
    </Box>
  );
}

export default memo(NotificationTotal);
